const ChildSafetyPage = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        padding: "32px 16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          padding: 24,
          background: "#09172E",
          border: "1px solid #2B315C",
          borderRadius: "20px",
          display: "flex",
          flexDirection: "column",
          gap: 24,
        }}
      >
        <div>
          <h1
            style={{
              color: "#FECF0C",
            }}
          >
            Child Safety Standards
          </h1>
          <br />
          <p>Last Updated: June 2026</p>
          <br />
          <p>
            At iCXeed, we are committed to protecting children and preventing
            Child Sexual Abuse and Exploitation (CSAE) on GameChanger.
          </p>
        </div>

        <div>
          <h2>Our Commitment</h2>
          <br />
          <p>
            We are committed to maintaining a safe environment for children and
            minors. Any content, behavior, or activity that exploits, abuses, or
            endangers children is strictly prohibited on GameChanger.
          </p>
          <br />
          <p>
            We have zero tolerance for any form of Child Sexual Abuse and
            Exploitation (CSAE), including:
          </p>
          <ul
            style={{
              color: "white",
              marginLeft: 26,
            }}
          >
            <li>Child sexual abuse material (CSAM)</li>
            <li>Child sexual exploitation</li>
            <li>Grooming or predatory behavior toward minors</li>
            <li>Sexualization of minors</li>
            <li>
              Any activity that endangers the safety or well-being of children
            </li>
          </ul>
          <br />
          <p>
            Users who engage in such activities may have their accounts
            suspended or permanently terminated and may be reported to
            appropriate law enforcement authorities when required.
          </p>
        </div>

        <div>
          <h2>Reporting Child Safety Concerns</h2>
          <br />
          <p>
            If you encounter content or behavior that may involve child
            exploitation, abuse, or other child safety concerns, please contact
            us immediately:
          </p>
          <p>
            <strong>Email:</strong>{" "}
            <a
              href="mailto:icxeeddevacc@gmail.com"
              style={{
                color: "white",
              }}
            >
              icxeeddevacc@gmail.com
            </a>
          </p>
          <br />
          <p>
            We review reports promptly and take appropriate action to protect
            users and comply with applicable laws.
          </p>
        </div>

        <div>
          <h2>Enforcement</h2>
          <br />
          <p>When violations of these standards are identified, we may:</p>
          <ul
            style={{
              color: "white",
              marginLeft: 26,
            }}
          >
            <li>Remove offending content</li>
            <li>Suspend or terminate user accounts</li>
            <li>Restrict access to platform features</li>
            <li>Report violations to relevant authorities when appropriate</li>
          </ul>
        </div>

        <div>
          <h2>Contact Information</h2>
          <br />
          <p>
            If you have questions regarding these Child Safety Standards, please
            contact:
          </p>
          <p>
            <strong>Developer:</strong> iCXeed
          </p>
          <p>
            <strong>Application:</strong> GameChanger
          </p>
          <p>
            <strong>Email:</strong>{" "}
            <a
              href="mailto:icxeeddevacc@gmail.com"
              style={{
                color: "white",
              }}
            >
              icxeeddevacc@gmail.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ChildSafetyPage;
